const _ = require('lodash')
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'fixed', 'buttons', 'middleMenu' ]

  connect() {
    this.fixed = false
    this.fixingClass = 'fixed top-0 left-0 right-0 shadow-md z-20'
    this.buttonsHiddenClass = 'hidden sm:flex'
    this.middleMenuHiddenClass = 'lg:hidden'
  }

  adjust = _.throttle(() => {
    let scrollPosition = Math.round(window.scrollY);
    if (scrollPosition > this.headerHeight()) {
      if (!this.fixed) {
        this.fixed = true
        document.body.style.paddingTop = `${this.fixedHeight()}px`
        this.fixedTarget.classList.add(...this.fixingClass.split(' '))
        this.buttonsTarget.classList.add(...this.buttonsHiddenClass.split(' '))
        this.middleMenuTarget.classList.add(...this.middleMenuHiddenClass.split(' '))
      }
    } else if (this.fixed) {
      this.fixed = false
      document.body.style.paddingTop = 0
      this.fixedTarget.classList.remove(...this.fixingClass.split(' '))
      this.buttonsTarget.classList.remove(...this.buttonsHiddenClass.split(' '))
      this.middleMenuTarget.classList.remove(...this.middleMenuHiddenClass.split(' '))
    }
  }, 200)

  headerHeight() {
    return this.element.getBoundingClientRect().height
  }

  fixedHeight() {
    return this.fixedTarget.getBoundingClientRect().height
  }
}
